import { useEffect } from "react";
import {
  isExternalHttpUrl,
  openExternalUrl,
} from "./externalNavigation";

/**
 * Capture-phase click handler for in-app <a href> that point off-site.
 * Always forces target=_blank style open so iOS home-screen mode is less likely
 * to swallow the navigation into a trapped white sheet.
 *
 * Does not see clicks inside cross-origin iframes (SoundCloud UI) — those are
 * handled separately via iframe sandbox on MusicPlayer.
 */
const useStandaloneExternalLinks = () => {
  useEffect(() => {
    const onClick = (event) => {
      // Only primary button, no modifier keys that mean "open elsewhere already"
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      const anchor = event.target?.closest?.("a[href]");
      if (!anchor) return;

      // Ignore download / explicit same-tab intent we don't use
      if (anchor.hasAttribute("download")) return;

      const href = anchor.getAttribute("href");
      if (!href || href.startsWith("#") || href.startsWith("mailto:")) return;
      if (href.startsWith("tel:") || href.startsWith("javascript:")) return;

      if (!isExternalHttpUrl(href)) return;

      event.preventDefault();
      event.stopPropagation();
      openExternalUrl(href);
    };

    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);
};

export default useStandaloneExternalLinks;
